<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// tableDataI: getdata().tableDataI,
				delCells: [],
				option1: getdata().option1,
				option2: getdata().option2,
				option3: getdata().option3,
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			selectchangetwo(e) {
				e['xfs_7_x_4'].cellType = '1'
			},
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(index) {
				if (this.tableDataI.length < 3) {
					return false;
				}
				// if (this.$notemptyandnull(this.tableDataI[index]['noty_0_x_1'].id)) {
				//     this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
				// }
				this.tableDataI.splice(index, 1);
				this.$emit('delCellsCode', this.delCells);
			},
			foraddhang() {
				this.tableDataI.push({
					disablednoty_0_x_tes2: false,
					disablednoty_0_x_tes3: false,
					disablednoty_0_x_tes4: false,
					disablednoty_0_x_tes5: false,
					disablednoty_0_x_tes6: false,
					disablednoty_0_x_tes7: false,
					disablednoty_0_x_tes8: false,
					disablednoty_0_x_tes9: false,
					disablednoty_0_x_tes10: false,
					disablednoty_0_x_tes11: false,
					disablednoty_0_x_tes12: false,
					disablednoty_0_x_tes13: false,
					disablednoty_0_x_tes14: false,
					disablednoty_0_x_tes15: false,
					disablednoty_0_x_tes16: false,
					disablednoty_0_x_tes17: false,
					disablednoty_0_x_tes18: false,
					disablednoty_0_x_tes19: false,
					disablednoty_0_x_tes20: false,
					tes1: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes2: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes3: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes4: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes5: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes6: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes7: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes8: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes9: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes10: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes11: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes12: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes13: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes14: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes15: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes16: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes17: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes18: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes19: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
					tes20: {
						cellCode: "ty_0_x_1",
						cellType: "1",
						cellVal: "0.00"
					},
				})
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>